import angular from 'angular';
import $ from 'jquery';

export default class UserProductSpecs {
  constructor($scope, $rootScope, UserProductService, UserSidebarService, UserService) {
    $scope.load_user_products = function() {
      $scope.loading = true;
      UserProductService.get_user_products(window.user_id).then(function(data) {
        $scope.user_products = data.user_products;
        $scope.loading = false;
        $scope.set_sidebar_specs();
      });
    };

    $scope.set_sidebar_specs = function() {
      var count = 0;
      angular.forEach($scope.user_products, function(p) {
        if (p.has_reels_specs || p.has_sheets_specs)
          count++;
      });
      var percentage = Math.floor(count / $scope.user_products.length * 100.0);
      $rootScope.$broadcast('set_sidebar_data', [0, 3, [{
        type: 'counter',
        value: count
      }, {
        type: 'percentage',
        value: percentage
      }]]);
    };

    $scope.delete_specs = function(user_product) {
      if (confirm('Are you sure you want to delete the specs?')) {
        UserProductService.delete_specs(user_product.id).then(function(data) {
          if (data.success) {
            var index = $scope.user_products.indexOf(user_product);
            $scope.user_products.splice(index, 1);
            $scope.set_sidebar_specs();
          }
        });
      }
    };

    $scope.open_view_specs_dialog = function(user_product_id) {
      $scope.$broadcast('open_view_specs_dialog', {
        user_product_id: user_product_id
      });
    };

    $scope.open_edit_specs_dialog = function(user_product_id, product_group_id) {
      $scope.$broadcast('open_edit_specs_dialog', {
        user_product_id: user_product_id,
        product_group_id: product_group_id
      });
    };

    $scope.open_dialog = function(dialog_id) {
      $.fancybox($('div#' + dialog_id), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'yes',
        afterClose: function() {
          $scope.load_user_products();
          $scope.load_specs_statuses();
        }
      });
    };

    $scope.add_multiple_specs = function() {
      UserProductService.get_user_products_without_specs(window.user_id).then(function(data) {
        $scope.products_without_specs = data.user_products;
        $scope.open_dialog('mass_edit_specs_dialog');
      });
    };

    $scope.copy_specs = function() {
      $scope.open_dialog('copy_specs_dialog');
    };

    $scope.update_specs_statuses = function() {
      $scope.updating_specs_statuses = true;
      UserService.update_specs_statuses(window.user_id, $scope.reel_specs_status, $scope.sheet_specs_status, $scope.rw_cutting_specs_status).success(function(data) {
        if (data.success)
          $scope.updating_specs_statuses = false;
      });
    };

    $scope.load_specs_statuses = function() {
      UserService.load_specs_statuses(window.user_id).success(function(data) {
        if (data.success) {
          $scope.reel_specs_status = data.reel_specs_status;
          $scope.sheet_specs_status = data.sheet_specs_status;
          $scope.rw_cutting_specs_status = data.rw_cutting_specs_status;
        }
      });
    };
    
    $scope.update_matching_settings = function() {
      $scope.updating_matching_settings = true;
      UserService.update_matching_settings(window.user_id, $scope.matching_settings).success(function(data) {
        if (data.success) {
          $scope.updating_matching_settings = false;
        }
      });
    };
    
    $scope.load_matching_settings = function() {
      UserService.load_matching_settings(window.user_id).success(function(data) {
        if (data.success) {
          $scope.matching_settings = data.matching_settings;
          if ($scope.matching_settings.enabled == undefined) {
            $scope.matching_settings.enabled = 0;
          }
        }
      });
    };
    
    $scope.update_campaign_settings = function() {
      $scope.updating_campaign_settings = true;
      UserService.update_campaign_settings(window.user_id, $scope.campaign_settings).success(function(data) {
        if (data.success) {
          $scope.updating_campaign_settings = false;
        }
      });
    };

    $scope.load_campaign_settings = function() {
      UserService.load_campaign_settings(window.user_id).success(function(data) {
        if (data.success) {
          $scope.campaign_settings = data.campaign_settings;
        }
      });
    };
    
    $scope.criterias = [
      {
        value: 0,
        title: 'No'
      },
      {
        value: 1,
        title: 'Yes'
      }
    ];

    $scope.percentages = [
      {
        value: 0,
        title: '0%'
      },
      {
        value: 1,
        title: '1%'
      },
      {
        value: 20,
        title: '20%'
      },
      {
        value: 40,
        title: '40%'
      },
      {
        value: 60,
        title: '60%'
      },
      {
        value: 80,
        title: '80%'
      },
      {
        value: 100,
        title: '100%'
      }
    ];
    
    $scope.operators = [
      {
        value: 1,
        title: '+'
      },
      {
        value: 2,
        title: '+/-'
      }
    ];
    
    $scope.specs = [
      {
        value: 0,
        title: 'ALL'
      },
      {
        value: 1,
        title: 'Only Yes'
      },
      {
        value: 2,
        title: 'Unknown or Yes'
      }
    ];
    
    $scope.cuts = [
      {
        value: 1,
        title: '1'
      },
      {
        value: 2,
        title: '2'
      },
      {
        value: 3,
        title: '3'
      },
    ];
    
    $scope.wastes = [
      {
        value: 0,
        title: '0'
      },
      {
        value: 1,
        title: '1'
      },
      {
        value: 2,
        title: '2'
      }
    ];
    
    $scope.ranges = [
      {
        value: 0,
        title: '0'
      },
      {
        value: 1,
        title: '+-0.5'
      },
      {
        value: 2,
        title: '+-1'
      }
    ];

    $scope.specs_status_options = [
      {
        id: 0,
        title: 'All'
      },
      {
        id: 1,
        title: 'Reels'
      },
      {
        id: 2,
        title: 'Sheets'
      }
    ];

    $scope.init = function() {
      $scope.reel_specs_status = window.reel_specs_status;
      $scope.sheet_specs_status = window.sheet_specs_status;
      $scope.rw_cutting_specs_status = window.rw_cutting_specs_status;
      $scope.reel_specs_statuses = UserService.get_specs_statuses();
      $scope.sheet_specs_statuses = UserService.get_specs_statuses();
      $scope.rw_cutting_specs_statuses = UserService.get_specs_statuses();
      $scope.products_without_specs = [];
      $scope.load_user_products();
      $scope.load_matching_settings();
      $scope.load_campaign_settings();
    };

    $scope.init();
  }
}

UserProductSpecs.$inject = ['$scope', '$rootScope', 'UserProductService', 'UserSidebarService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-specs.ctrl.js